import React from 'react';
import styles from './RightSidebarMenu.module.scss';
import { Icon } from '../Icon';
import { useLibraryContext } from '../../context/LibraryContext';
import { useTranslation } from 'react-i18next';

const RightSidebarHeader = ({ selectedVideos, selectedFolders }) => {
  const { toggleUnselectCards, toggleUnselectFolders } = useLibraryContext();
  const { t } = useTranslation();

  const handleCloseClick = () => {
    toggleUnselectCards();
    toggleUnselectFolders();
  };

  return (
    <div className={styles.header}>
      <h3>
        {selectedVideos > 0 && <span>{`${selectedVideos} ${selectedVideos === 1 ? t('general.right_sidebar.videos') : t('sidebar.videos').toLowerCase()}`}</span>}
        {selectedVideos > 0 && selectedFolders > 0 && <span> and </span>}
        {selectedFolders > 0 && <span>{`${selectedFolders} ${selectedFolders === 1 ? t('general.right_sidebar.folder') : t('sidebar.folders').toLowerCase()}`}</span>}
        <span> {t('general.right_sidebar.selected')}</span>
      </h3>
      <Icon className={styles.closeIcon} onClick={handleCloseClick} src="close" />
    </div>
  );
};

export default RightSidebarHeader;
